import { toMoneyFormat } from "utils";
import React from "react";

export interface CourseExampPaymentApi {
  id: number;
  price: number;
  attempts: number;
  order: number;
}
interface ExamPaymentPoliciesPreviewProps {
  payments: CourseExampPaymentApi[];
}
export const ExamPaymentPoliciesPreview = ({ payments }: ExamPaymentPoliciesPreviewProps) => {
  const resolveAttempts = (attempts: number) => {
    if (!attempts || attempts === 0) return "każda kolejna próba";
    if (attempts === 1) return "1 próba";
    if (attempts > 1) return `${attempts} próby`;
  };
  if (payments.length < 1) return null;
  return (
    <div>
      <div className="text-sm font-semibold">Polityka płatności</div>
      <div className="flex flex-col">
        {payments
          .sort((a, b) => a.order - b.order)
          .map((payment) => (
            <span className="text-sm" key={payment.id}>
              {resolveAttempts(payment.attempts)} w cenie{" "}
              <span className="font-semibold">{toMoneyFormat(payment.price)} PLN</span>
            </span>
          ))}
      </div>
    </div>
  );
};
